import React from 'react';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const ProductsPriceMarginHistory = ({ productsPriceMarginHistory }) => {
  const { t } = useAutoTranslation;
  return (
    <div className="card-box">
      <h4 className="header-title">{t('История изменений средней закупочной цены')}</h4>
      <div style={{ overflowY: 'scroll', height: '300px' }}>
        <table className="table table-centered">
          <thead className="thead-light">
            <tr>
              <th>Дата</th>
              <th>Цена</th>
            </tr>
          </thead>
          <tbody>
            {productsPriceMarginHistory?.map((history) => (
              <tr>
                <td>{new Date(history.date).toLocaleString()}</td>
                <td>{history.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductsPriceMarginHistory;
